import { createAsyncThunk } from '@reduxjs/toolkit';
import WithdrawalService from '../../../api/services/WithdrawalService';

export const fetchWithdrawals = createAsyncThunk('withdrawal/fetchWithdrawals', async ({ page }) => {
  return await WithdrawalService.fetchWithdrawals(page);
});

export const requestWithdrawal = createAsyncThunk('withdrawal/requestWithdrawal', async requestData => {
  return await WithdrawalService.requestWithdrawal(requestData);
});

export const deleteWithdrawalMethod = createAsyncThunk('withdrawal/deleteWithdrawalMethod', async requestData => {
  return await WithdrawalService.deleteWithdrawalMethod(requestData);
});

export const createMassPayUser = createAsyncThunk('withdrawal/createMassPayUser', async requestData => {
  return await WithdrawalService.createMassPayUser(requestData);
});

export const fetchMassPayActivationUrl = createAsyncThunk('withdrawal/fetchMassPayActivationUrl', async () => {
  return await WithdrawalService.fetchMassPayActivationUrl();
});

export const fetchMassPayCountries = createAsyncThunk('withdrawal/fetchMassPayCountries', async () => {
  return await WithdrawalService.fetchMassPayCountries();
});
